import { combineReducers } from 'redux';
import userProfileReducer from './userProfileReducer';

export default combineReducers({
    userProfile: userProfileReducer
})


// WEBPACK FOOTER //
// ./src/reducers/index.js